require('lightgallery')

$(document).ready(function() {
    $("#lightgallery").lightGallery(
        {getCaptionFromTitleOrAlt: true}
    );
});
